import Representation3dTypeEnum from "./Representation3dTypeEnum";

export default class Representation3d  {
    
    representationType: Representation3dTypeEnum = Representation3dTypeEnum.NotDefined;
    materialId: number | null;
    
    constructor(representationType: Representation3dTypeEnum, materialId: number | null) {
        this.representationType = representationType;
        this.materialId = materialId;
    }

    clone() : Representation3d {
        throw new Error("Method 'clone' must be implemented.");
    }
}